import { Icon, type IconTone } from './Icon';

/**
 * Треугольник с восклицательным знаком: предупреждение перед необратимым.
 *
 * Отдельный от WarningIcon намеренно. Тот — сота, знак Мезы, и стоит в шапке
 * «доступа нет»: это состояние. Треугольник читается как дорожный знак и
 * появляется ровно там, где отменить будет нельзя.
 */
export function AlertIcon({ size = 16, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={18} tone={tone}>
      <path d="M9 1.4 L17 14.6 H1 Z" strokeWidth={1.2} />
      <path d="M9 6 v4.2" strokeWidth={1.2} />
      <path d="M9 11.8 v1.1" strokeWidth={1.2} />
    </Icon>
  );
}
